import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableItem = ({ id, index, children, getColumnDisplayName, activeId }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const isActive = activeId === id;
  const isOver = activeId && activeId !== id;

  return (
    <div
      ref={setNodeRef}
      style={{
        ...style,
        padding: '0.625rem 0.75rem',
        margin: 0,
        backgroundColor: isDragging 
          ? '#e0e7ff' 
          : isActive
          ? '#e0e7ff'
          : isOver
          ? '#f3f4f6'
          : '#f3f4f6',
        border: 'none',
        borderTop: 'none',
        borderRight: 'none',
        borderBottom: 'none',
        borderLeft: 'none',
        outline: 'none',
        borderRadius: '6px',
        fontSize: '0.8125rem',
        fontWeight: '500',
        width: '100%',
        boxSizing: 'border-box',
        cursor: isDragging ? 'grabbing' : 'grab',
        transition: 'all 0.15s ease',
        transform: isDragging ? 'scale(1.02)' : 'scale(1)',
        userSelect: 'none',
        boxShadow: 'none',
        opacity: isDragging ? 0.3 : 1,
        position: 'relative',
        zIndex: isDragging ? 1000 : isOver ? 10 : 1,
      }}
      onFocus={(e) => {
        e.currentTarget.style.outline = 'none';
        e.currentTarget.style.border = 'none';
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.outline = 'none';
        e.currentTarget.style.border = 'none';
      }}
      {...attributes}
      {...listeners}
    >
      
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem'
        }}>
          <div style={{
            width: '18px',
            height: '18px',
            backgroundColor: isDragging ? '#6366f1' : '#6b7280',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '10px',
            fontWeight: '600',
            flexShrink: 0
          }}>
            {index + 1}
          </div>
          <span style={{
            color: isDragging ? '#4f46e5' : '#374151',
            fontSize: '0.8125rem',
            fontWeight: '500'
          }}>
            {getColumnDisplayName(id)}
          </span>
        </div>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          opacity: isDragging ? 0.7 : 0.4,
          transition: 'opacity 0.15s ease'
        }}>
          <div style={{
            width: '3px',
            height: '3px',
            backgroundColor: '#9ca3af',
            borderRadius: '50%'
          }} />
          <div style={{
            width: '3px',
            height: '3px',
            backgroundColor: '#9ca3af',
            borderRadius: '50%'
          }} />
          <div style={{
            width: '3px',
            height: '3px',
            backgroundColor: '#9ca3af',
            borderRadius: '50%'
          }} />
        </div>
      </div>
    </div>
  );
};

export default SortableItem;
